import Constants from "../constants";
import { LogMessage } from "../helper-func";
const API_SERVER = Constants.API_SERVER;
const NumberOfScreenshotsPerReq = 14;
function getRequestedUrl(url) {
    if (url.startsWith('/')) {
        url = url.substring(1);
    }
    return API_SERVER + url;
}
function sendRequest(request, callback) {
    fetch(request)
        .then((response) => {
        // LogMessage(response);
        if (!response.ok) {
            throw new Error(`status code from server: ${response.status}`);
        }
        return response.json();
    })
        .then(data => callback(true, data))
        .catch((error) => {
        LogMessage(`sendRequest to ${request.url} with error:`);
        LogMessage(error);
        callback(false, error);
    });
}
function buildPostRequest(url, contentType, body) {
    const headers = {};
    if (contentType) {
        headers['Content-Type'] = contentType;
    }
    return new Request(getRequestedUrl(url), {
        method: 'POST',
        mode: 'cors',
        headers: headers,
        body: body
    });
}
export function PostByJson(url, data, callback) {
    const request = buildPostRequest(url, 'application/json', JSON.stringify(data));
    sendRequest(request, callback);
}
export function PostByFormUrlEncoded(url, data, callback) {
    const urlEncodedData = new URLSearchParams();
    for (const key in data) {
        if (data.hasOwnProperty(key)) {
            urlEncodedData.append(key, data[key]);
        }
    }
    const request = buildPostRequest(url, 'application/x-www-form-urlencoded', urlEncodedData);
    sendRequest(request, callback);
}
export function PostByFormData(url, data, callback) {
    const formData = new FormData();
    for (const key in data) {
        if (data.hasOwnProperty(key)) {
            formData.append(key, data[key]);
        }
    }
    const request = buildPostRequest(url, 'multipart/form-data', formData);
    sendRequest(request, callback);
}
function convertBase64ToBinary(base64String) {
    const binaryString = window.atob(base64String);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes;
}
export function UploadScreenshot(imageElement, url, annotation, token, imgSize, numOfPages, callback) {
    if (!imageElement.src.startsWith("data:image")) {
        throw Error("image src is not base64 encoded.");
    }
    const base64Img = imageElement.src;
    let imageFormat = "jpg";
    if (base64Img.startsWith("data:image/png;")) {
        imageFormat = "png";
    }
    // Remove data URL prefix if present
    const base64Str = base64Img.replace(/^data:image\/\w+;base64,/, '');
    const binImg = convertBase64ToBinary(base64Str);
    const formData = new FormData();
    const imgBlob = new Blob([binImg], { type: `image/${imageFormat}` });
    LogMessage(`uploading image with size: ${imgBlob.size}`);
    formData.append("image", imgBlob, `screenshot.${imageFormat}`);
    formData.append("format", imageFormat);
    formData.append("url", url);
    formData.append("annotation", annotation);
    formData.append("token", token);
    formData.append("width", imgSize.width.toString());
    formData.append("height", imgSize.height.toString());
    formData.append("pages", numOfPages.toString());
    const request = buildPostRequest("/screenshot/upload", null, formData);
    sendRequest(request, callback);
}
export function UpdateScreenshot(screenshotId, annotation, userToken, tags, callback) {
    const formData = new FormData();
    formData.append("id", screenshotId);
    if (annotation != null) {
        formData.append("annotation", annotation);
    }
    formData.append("token", userToken);
    if (tags != null) {
        formData.append("tags", tags.join("\t"));
    }
    const request = buildPostRequest('/screenshot/update', null, formData);
    sendRequest(request, callback);
}
export function GetImageUrlFromToken(imageToken) {
    return getRequestedUrl(`/image/${imageToken}`);
}
function buildGetRequest(url, data) {
    let requested_url = getRequestedUrl(url);
    if (data) {
        const urlEncodedData = new URLSearchParams();
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                urlEncodedData.append(key, data[key]);
            }
        }
        requested_url = requested_url + '?' + urlEncodedData.toString();
    }
    return new Request(requested_url, {
        method: 'GET',
        mode: 'cors',
    });
}
export function DeleteScreenshot(screenshotId, userToken, callback) {
    const formData = new FormData();
    formData.append("id", screenshotId);
    formData.append("token", userToken);
    const request = buildPostRequest('/screenshot/delete', null, formData);
    sendRequest(request, callback);
}
export function LoadScreenshot(screenshotId, callback) {
    const request = buildGetRequest(`/screenshot/${screenshotId}`, null);
    sendRequest(request, callback);
}
export function ListScreenshots(userToken, start, length, callback) {
    if (start < 0) {
        start = 0;
    }
    if (length <= 0) {
        length = NumberOfScreenshotsPerReq;
    }
    const request = buildGetRequest('/screenshot/list', {
        token: userToken,
        start: start.toString(),
        num: length.toString(),
    });
    sendRequest(request, callback);
}
export function LoginWithGoogle(email, googleSub, iconUrl, name, callback) {
    const formData = new FormData();
    formData.append('email', email);
    formData.append('provider', 'google');
    formData.append('icon_url', iconUrl);
    formData.append('name', name);
    formData.append('token', googleSub);
    const request = buildPostRequest('/user/login_with_auth_provider', null, formData);
    sendRequest(request, callback);
}
// The price unit is dollar, and we change it to cents when send it to server to avoid floats.
export function BuyGrabitService({ token, serviceLength, quantity, price, fromNow }, callback) {
    const formData = new FormData();
    formData.append('token', token);
    formData.append('service_length', serviceLength.toString());
    formData.append('quantity', quantity.toString());
    formData.append('price', Math.round(price * 100).toString());
    formData.append('from_now', fromNow.toString());
    const request = buildPostRequest('/p/create_checkout_session', null, formData);
    sendRequest(request, callback);
    // callback(true, {url: 'https://buy.stripe.com/test_4gw7uV0XF12U16QaEE'});
}
export function ConfirmTransaction({ session_id }, callback) {
    const formData = new FormData();
    formData.append('sid', session_id);
    const request = buildPostRequest('/p/checkout_completed', null, formData);
    sendRequest(request, callback);
}
export function CancelTransaction({ session_id }, callback) {
    const formData = new FormData();
    formData.append('sid', session_id);
    const request = buildPostRequest('/p/checkout_canceled', null, formData);
    sendRequest(request, callback);
}
export function GetUserProfile({ token }, callback) {
    const formData = new FormData();
    formData.append('token', token);
    const request = buildPostRequest('/user/profile', null, formData);
    sendRequest(request, callback);
}
export async function GetUserProfileAsync({ token }) {
    return new Promise((resolve, reject) => {
        GetUserProfile({ token }, (success, result) => {
            if (success) {
                resolve(result);
            }
            else {
                resolve({});
            }
        });
    });
}
export function GetProductsInStock(callback) {
    const request = buildGetRequest('/p/products', null);
    sendRequest(request, callback);
}
